'use client';

import React, { createContext, useState, ReactNode, useEffect } from 'react';
import { Loading } from '@/components/loader/Loading';

interface PageLoaderProviderProps {
  children: ReactNode;
}

export const PageLoaderContext = createContext<{
  loading: boolean;
  setLoading: React.Dispatch<React.SetStateAction<boolean>>;
}>({
  loading: false,
  setLoading: () => {},
});

export const PageLoaderProvider: React.FC<PageLoaderProviderProps> = ({
  children,
}) => {
  const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    const handleStart = () => setLoading(true);
    const handleComplete = () => setLoading(false);

    window.addEventListener('beforeunload', handleStart);
    window.addEventListener('onload', handleComplete);
    window.addEventListener('error', handleComplete);

    return () => {
      window.removeEventListener('beforeunload', handleStart);
      window.removeEventListener('onload', handleComplete);
      window.removeEventListener('error', handleComplete);
    };
  }, []);

  return (
    <PageLoaderContext.Provider value={{ loading, setLoading }}>
      {children}
      <Loading isLoading={loading} />
    </PageLoaderContext.Provider>
  );
};
